import localforage from 'localforage';
import logger from '~/services/logger';
import { isLoggedInClientState } from './is-logged-in-client-state';
import {
  clearLocalStorageByText,
  getUserIdentifierUUID,
} from '~/services/layout/layout';
import { CLEENG_LOCAL_STORAGE_TEXT } from '~/utils/storefront';

export const USER_IDENTIFIER_KEY: string = 'userIdentifier';

export async function getLocalStorageUserSuffix(): Promise<string> {
  try {
    if (!isClientStorageAvailable()) return '';

    const APP_VERSION_UUID: string = window.versionInfo?.APP_VERSION_UUID;

    if (!APP_VERSION_UUID) throw Error('No APP_VERSION_UUID available');

    const userIdentifier: string = await getLocalStorageUserIdentifier();

    return `${APP_VERSION_UUID}${userIdentifier}`;
  } catch (error: any) {
    logger.error(`getLocalStorageUserSuffix: ${error.message}`);
    return '';
  }
}

export async function setLocalStorageUserIdentifier(
  userIdentifier: string
): Promise<void> {
  if (!isClientStorageAvailable() || !userIdentifier) return;

  await localforage.setItem(USER_IDENTIFIER_KEY, userIdentifier);
}

async function getLocalStorageUserIdentifier(): Promise<string> {
  if (!isClientStorageAvailable()) return '';

  const userIdentifier: string | null = await localforage.getItem(
    USER_IDENTIFIER_KEY
  );

  if (userIdentifier === null) return '';

  return `-${userIdentifier}`;
}

async function removeLocalStorageUserIdentifier(): Promise<void> {
  if (!isClientStorageAvailable()) return;

  await localforage.removeItem(USER_IDENTIFIER_KEY);
}

export function isClientStorageAvailable(): boolean {
  try {
    return (
      typeof window !== 'undefined' &&
      typeof window.indexedDB !== 'undefined' &&
      typeof window.localStorage !== 'undefined' &&
      window?.versionInfo
    );
  } catch (e) {
    return false;
  }
}

export async function setLocalStorageOnLogin(loginData: any): Promise<void> {
  if (!isClientStorageAvailable()) return;

  const userIdentifier = getUserIdentifierUUID(loginData);
  await setLocalStorageUserIdentifier(userIdentifier);
  await isLoggedInClientState().set(true);
}

export async function clearLocalStorageOnLogout(): Promise<void> {
  if (!isClientStorageAvailable()) return;

  await isLoggedInClientState().set(false);
  await removeLocalStorageUserIdentifier();
  clearLocalStorageByText(CLEENG_LOCAL_STORAGE_TEXT);
}
